import DirectDebitPayment from "../pages/DirectDebitPayment"

export class SessionStatus {
  static INITIALIZED = 'INITIALIZED'
  static PENDING = 'PENDING'
  static VERIFICATION_PENDING = 'VERIFICATION_PENDING'
  static OTP_VERIFICATION = 'VERIFIED'
  static CONFIRMATION = 'CONFIRMATION'
  static CONFIRMED = 'CONFIRMED'
  static SUCCESS = 'SUCCESS'
  static FAILED = 'FAILED'
  static CANCELLED = 'CANCELLED'
  static EXPIRED = 'EXPIRED'

  constructor(type) {
    this.type = type
  }
}

export const SESSION_FUNDING_SOURCE_PAGES = {
  BANK_ACCOUNT_DIRECT_DEBIT: <DirectDebitPayment />
};